<template>

  <b-sidebar id="sidebar-tutorial" :title="$t('navbar.guide')" shadow>
    
    <!--template v-slot:footer="{ hide }">
      <b-button size="sm" @click="hide">Fermer</b-button>
    </template-->

    <div class="px-3 py-2" >
      <p>{{$t('guide.1')}}</p>
      <p>{{$t('guide.2')}}</p>
      <p>{{$t('guide.3')}}</p>
      <p>{{$t('guide.4')}}</p>
      <p>{{$t('guide.5')}}</p>
      <p>{{$t('guide.6')}}</p>
      <p>{{$t('guide.7')}}</p>
      <p>{{$t('guide.8')}}</p>
      <p>{{$t('guide.9')}}</p>
      <p>{{$t('guide.10')}}</p>
      <p>{{$t('guide.11')}}</p>
    </div>
  </b-sidebar>
  
</template>
<script>



export default {
  name: 'SidebarComponent',

   data() {
      return {
        show: false,
        squarred: '\u00B2'
      }
    },

  components: {
  },

  async created() {
  },

  async mounted() {
  }

}
</script>

<style scoped>


</style>
